module.exports = __webpack_public_path__ + "img/SX.999d5f86.png";